module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.674f50d2.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./~/font-awesome/fonts/fontawesome-webfont.eot
 ** module id = 659
 ** module chunks = 0
 **/